/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from "../Recursos/fondo_seccion.svg";
import logo from "../Recursos/logo_blanco.svg";
import {ArrowBack} from "@mui/icons-material";
import {useResponsive} from "../Modulo_Responsive/Hooks/useResponsive";
import {irUrl} from "../Utilidades/irUrl";
import {URLPAGINA} from "../Constantes";

const Footer = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `url(${fondo})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                mt: !masSM ? -28 : 0
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', mt: 24, mb: 8}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-end'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 32, color: '#fff', fontWeight: 800, lineHeight: 1.1}}>Tu
                                        puente
                                        al nuevo comercio
                                        <br/>
                                        <span
                                            style={{
                                                backgroundClip: 'text',
                                                backgroundImage: 'linear-gradient(89deg, #1F7DFE 14.3%, #00FFE1 57.84%)',
                                                color: 'transparent'
                                            }}>
                                    inteligente

                                </span>
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{fontSize: 15, fontWeight: 400}}>
                                        Conectamos tecnología blockchain, activos físicos y logística global para
                                        ofrecer una
                                        forma más segura, eficiente e inteligente de mover valor en el mundo.
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={2}
                                    >


                                        <Button
                                            onClick={() => irUrl(URLPAGINA)}
                                            startIcon={<ArrowBack/>} sx={{px: 4.2}}>Regresar a Pagina</Button>


                                    </Grid>

                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}}
                              sx={{justifyContent: 'flex-end', mt: sCell ? 1 : 0}}>
                            <img src={logo} width={sCell ? 100 : 150} height={'auto'}/>
                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 10}}>
                    <Typography>© Copyright 2024 - 2025 | BitNova World v0.0.6</Typography>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Footer    